var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"delete-undo-toast"},[_c('span',{staticClass:"delete-undo-message"},[_vm._v(_vm._s(_vm.message))]),_c('button',{staticClass:"delete-undo-btn",attrs:{"type":"button","cy":"delete-undo-btn"},on:{"click":_vm.handleUndo}},[_vm._v(" "+_vm._s(_vm.undoLabel)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }